export default {
  funcionarioId: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  dtInicioGiroCarteira: {
    value: null,
    required: true,
    state: null
  },
  qtdVisitasPf: {
    value: null,
    required: true,
    state: null
  },
  qtdVisitasPj: {
    value: null,
    required: true,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/movimentacoes/giroCarteira/components/add/form.js